export default "__VITE_ASSET__13dFCi50__"